module.exports = __webpack_public_path__ + "img/white_paper4.a55d8567.png";